import { WorkOrder } from "@/services/backend/vbs/work-orders/types/work-order";
import { useState } from "react";
import {
  UpdateTeamLeaderRequest,
  useVbsWorkOrderUpdateTeamLeaderMutation,
} from "@/services/backend/vbs/work-orders/api/work-order-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import { TextInputField } from "@/shared/components/field/input-field";
import t from "@/lang/lang";

export function WorkOrderTeamLeaderInput({
  workOrder,
  disabled,
}: {
  workOrder: WorkOrder;
  disabled?: boolean;
}) {
  const [request, setRequest] = useState<UpdateTeamLeaderRequest>({
    id: workOrder.id,
    teamLeaderId: workOrder.teamLeaderId,
  });
  const mutation = useVbsWorkOrderUpdateTeamLeaderMutation();

  useDebouncedMutation(request, setRequest, mutation, {
    id: workOrder.id,
    teamLeaderId: workOrder.teamLeaderId,
  });

  return (
    <TextInputField
      label={t("Teamleiter")}
      text={request.teamLeaderId}
      onTextChange={(teamLeaderId) => setRequest({ ...request, teamLeaderId })}
      fieldName="teamLeaderId"
      debounce={false}
      disabled={disabled}
    />
  );
}
